const MAX_RETRIES_DEFAULT = 5;
const DEFAULT_INTERVAL_MILLISECONDS = 1200;

async function ctPromiseRetry(
	fn: () => Promise<Response>,
	retries = MAX_RETRIES_DEFAULT,
	retryIntervalMillis = DEFAULT_INTERVAL_MILLISECONDS,
	previousErrorResponse?: Error,
): Promise<Response> {
	return retries
		? fn().then(async (response) => {
				if (response.ok === false) {
					await new Promise((resolve) =>
						setTimeout(resolve, retryIntervalMillis),
					);
					return ctPromiseRetry(
						fn,
						retries - 1,
						retryIntervalMillis,
						new Error(response.statusText),
					);
				}

				return response;
			})
		: Promise.reject(previousErrorResponse ?? new Error("Max retries reached"));
}

export default ctPromiseRetry;
